import { create } from 'zustand'

interface ModalDescriptionTooLongState {
  isOpen: boolean
  isLoading: boolean
  propertyId: string
  primaryAction: () => void
  secondaryAction: () => void
  setIsOpen: (val: boolean) => void
  setIsLoading: (val: boolean) => void
  setPropertyId: (val: string) => void
  setPrimaryAction: any
  setSecondaryAction: any
}

const initialState = {
  isOpen: false,
  isLoading: false,
  propertyId: '',
  primaryAction: () => null,
  secondaryAction: () => null
}

export const useModalDescriptionTooLongStore =
  create<ModalDescriptionTooLongState>()((set) => ({
    ...initialState,
    setIsOpen: (isOpen) => set({ isOpen }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setPropertyId: (propertyId) => set({ propertyId }),
    setPrimaryAction: (primaryAction: any) => set({ primaryAction }),
    setSecondaryAction: (secondaryAction: any) => set({ secondaryAction })
  }))
